import { petcoColors, petcoSpacing, petcoTypeSystem } from './config';

export const petcoTheme = {

  // COLORS
  white: petcoColors.white,
  grey: petcoColors.grey,
  greyLight1: petcoColors.greyLight1,
  greyLight2: petcoColors.greyLight2,
  greyLight3: petcoColors.greyLight3,
  greyDark1: petcoColors.greyDark1,
  greyDark2: petcoColors.greyDark2,
  greyDark3: petcoColors.greyDark3,
  greyDark4: petcoColors.greyDark4,
  blue: petcoColors.blue,
  blueLight1: petcoColors.blueLight1,
  blueLight4: petcoColors.blueLight4,
  blueDark1: petcoColors.blueDark1,
  blueDark2: petcoColors.blueDark2,
  green: petcoColors.green,
  greenLight1: petcoColors.greenLight1,
  greenLight2: petcoColors.greenLight2,
  greenLight3: petcoColors.greenLight3,
  red: petcoColors.red,
  redLight1: petcoColors.redLight1,
  redLight2: petcoColors.redLight2,
  redDark1: petcoColors.redDark1,
  orange: petcoColors.orange,
  orangeLight1: petcoColors.orangeLight1,
  blueDaker1: petcoColors.blueDaker1,
  blueDarker2: petcoColors.blueDarker2,
  blueDarker3: petcoColors.blueDarker3,
  greyLighter1: petcoColors.greyLighter1,
  greyLighter2: petcoColors.greyLighter2,
  yellow1: petcoColors.yellow1,
  yellow2: petcoColors.yellow2,
  petcoYellow: petcoColors.petcoYellow,
  petcoBlue: petcoColors.petcoBlue,
  greenLight4: petcoColors.greenLight4,
  greyLighter3: petcoColors.greyLighter3,

  primary: {
    main: petcoColors.petcoBlue,
    dark: petcoColors.blueDarker3,
    contrastText: petcoColors.white,
  },
  secondary: {
    main: petcoColors.orange,
    light: petcoColors.orangeLight1,
    dark: petcoColors.black,
    contrastText: petcoColors.white,
  },
  tertiary: {
    main: petcoColors.green,
    light: petcoColors.greenLight1,
    contrastText: petcoColors.white,
  },
  disabled: {
    main: petcoColors.greyLighter2,
    dark: petcoColors.greyLighter2,
    contrastText: petcoColors.greyDark3,
  },
  background: {
    main: petcoColors.greyLight1,
  },
  content: {
    title: petcoColors.greyDark3,
    text: petcoColors.black,
    placeholder: petcoColors.greyDark1,
    link: petcoColors.blue,
    link_visited: petcoColors.blueDark1,
  },
  border: {
    main: petcoColors.greyLight2,
    light: petcoColors.greyLight3,
    dark: petcoColors.greyLight4,
  },
  status: {
    danger: petcoColors.red,
    warning: petcoColors.orange,
    success: petcoColors.green,
  },
  gradient: {
    light: petcoColors.gradientLight,
    dark: petcoColors.gradientDark,
  },

  // TYPOGRAPH
  fontFamily: 'PetcoCircularTT, sans-serif',
  headingFontFamily: petcoTypeSystem.headingFontFamily,
  bodyFontFamily: petcoTypeSystem.bodyFontFamily,

  headingLineHeightMobile: petcoTypeSystem.headingLineHeightMobile,
  headingMobile: {
    micro: petcoTypeSystem.headingMicroMobile,
    small: petcoTypeSystem.headingSmallMobile,
    medium: petcoTypeSystem.headingMediumMobile,
    large: petcoTypeSystem.headingLargeMobile,
    xLarge: petcoTypeSystem.headingXLargeMobile,
  },

  headingLineHeight: petcoTypeSystem.headingLineHeight,
  heading: {
    micro: petcoTypeSystem.headingMicro,
    xSmall: petcoTypeSystem.headingXSmall,
    small: petcoTypeSystem.headingSmall,
    medium: petcoTypeSystem.headingMedium,
    large: petcoTypeSystem.headingLarge,
    xLarge: petcoTypeSystem.headingXLarge,
  },

  bodyLineHeight: petcoTypeSystem.bodyLineHeight,
  body: {
    micro: petcoTypeSystem.bodyMicro,
    small: petcoTypeSystem.bodySmall,
    medium: petcoTypeSystem.bodyMedium,
    large: petcoTypeSystem.bodyLarge,
    xLarge: petcoTypeSystem.bodyXLarge,
  },

  fontWeight: {
    extraLight: petcoTypeSystem.extraLight,
    light: petcoTypeSystem.light,
    regular: petcoTypeSystem.regular,
    semiBold: petcoTypeSystem.semiBold,
    bold: petcoTypeSystem.bold,
    extraBold: petcoTypeSystem.extraBold,
    black: petcoTypeSystem.black,
  },

  // SPACING
  inset: {
    micro: petcoSpacing.micro,
    xSmall: petcoSpacing.xSmall,
    small: petcoSpacing.small,
    medium: petcoSpacing.medium,
    large: petcoSpacing.large,
    xLarge: petcoSpacing.xLarge,
  },

  insetSquish: {
    small: [petcoSpacing.xSmall, petcoSpacing.small].join(' '),
    medium: [petcoSpacing.small, petcoSpacing.medium].join(' '),
    large: [petcoSpacing.medium, petcoSpacing.large].join(' '),
  },

  insetStrech: {
    small: ['.75rem', petcoSpacing.small].join(' '),
    medium: ['1.5rem', petcoSpacing.medium].join(' '),
  },

  stack: {
    micro: ['0', '0', petcoSpacing.micro, '0'].join(' '),
    xSmall: ['0', '0', petcoSpacing.xSmall, '0'].join(' '),
    small: ['0', '0', petcoSpacing.small, '0'].join(' '),
    medium: ['0', '0', petcoSpacing.medium, '0'].join(' '),
    large: ['0', '0', petcoSpacing.large, '0'].join(' '),
    xLarge: ['0', '0', petcoSpacing.xLarge, '0'].join(' '),
  },

  inline: {
    micro: ['0', petcoSpacing.micro, '0', '0'].join(' '),
    xSmall: ['0', petcoSpacing.xSmall, '0', '0'].join(' '),
    small: ['0', petcoSpacing.small, '0', '0'].join(' '),
    medium: ['0', petcoSpacing.medium, '0', '0'].join(' '),
    large: ['0', petcoSpacing.large, '0', '0'].join(' '),
    xLarge: ['0', petcoSpacing.xLarge, '0', '0'].join(' '),
  },

};
